import { IkasImage } from "../../../image";

export enum IkasProductOptionSelectType {
  BOX = "BOX",
  SELECT = "SELECT",
  SWATCH = "SWATCH",
}

export enum IkasProductOptionType {
  CHECKBOX = "CHECKBOX",
  CHOICE = "CHOICE",
  COLOR_PICKER = "COLOR_PICKER",
  DATE_PICKER = "DATE_PICKER",
  FILE = "FILE",
  IMAGE = "IMAGE",
  TEXT = "TEXT",
  TEXT_AREA = "TEXT_AREA",
}

export type IkasProductOptionOtherPrice = {
  currencyCode: string;
  price: number;
};

export type IkasProductOptionSelectValue = {
  id: string;
  order: number;
  value: string;
  price: number | null;
  otherPrices: IkasProductOptionOtherPrice[] | null;
  thumbnailImageId: string | null;
  colorCode: string | null;
  thumbnailImage: IkasImage | null;
};

export type IkasProductOptionSelectSettings = {
  type: IkasProductOptionSelectType;
  minSelect: number | null;
  maxSelect: number | null;
  values: IkasProductOptionSelectValue[];
};

export type IkasProductOptionDateSettings = {
  min: Date | null;
  max: Date | null;
  minRelativeNextDate: number | null;
  maxRelativeNextDate: number | null;
};

export type IkasProductOptionTextSettings = {
  min: number | null;
  max: number | null;
};

export type IkasProductOptionFileSettings = {
  allowedExtensions: string[] | null;
  minQuantity: number | null;
  maxQuantity: number | null;
};

export type IkasProductOption = {
  id: string;
  productOptionSetId: string;
  name: string;
  order: number;
  type: IkasProductOptionType;
  selectSettings: IkasProductOptionSelectSettings | null;
  textSettings: IkasProductOptionTextSettings | null;
  fileSettings: IkasProductOptionFileSettings | null;
  dateSettings: IkasProductOptionDateSettings | null;
  price: number | null;
  otherPrices: IkasProductOptionOtherPrice[] | null;
  isOptional: boolean;
  optionalText: string | null;
  requiredOptionId: string | null;
  requiredOptionValueIds: string[] | null;

  // Extra
  values: string[];
  childOptions: IkasProductOption[];
};
